var deviceWidths = {
  smallMobile: '320px',
  mobile: '375px',
  largeMobile: '414px',
  xLargeMobile: '435px',
  mobileLandscape: '480px',
  mobileLandscapeMax: '479px',
  largeMobileLandscape: '568px',
  largeMobileLandscapeMax: '567px',
  tablet: '768px',
  tabletMax: '767px',
  desktop: '975px',
  desktopMax: '974px',
  tabletLandscape: '1024px',
  tabletLandscapeMax: '1023px',
  mediumDesktop: '1280px',
  mediumDesktopMax: '1278px',
  largeDesktop: '1680px',
  largeDesktopMax: '1679px',
  xLargeDesktop: '1920px'
};

export { deviceWidths };
//# sourceMappingURL=widths.js.map
